import docker from "../assets/icons/Docker.png";
import expo from "../assets/icons/expo.png";
import express from "../assets/icons/Express.png";
import git from "../assets/icons/Git.png";
import java from "../assets/icons/Java.png";
import junit from "../assets/icons/JUnit.png";
import mongodb from "../assets/icons/MongoDB.png";
import nginx from "../assets/icons/NGINX.png";
import node from "../assets/icons/Node.js.png";
import postgres from "../assets/icons/PostgresSQL.png";
import rabbit from "../assets/icons/RabbitMQ.png";
import react from "../assets/icons/React.png";
import sonar from "../assets/icons/SonarQube.png";
import spring from "../assets/icons/Spring.png";
import tailwind from "../assets/icons/Tailwind-css.png";

const icons = {
    docker,
    expo,
    express,
    git,
    java,
    junit,
    mongodb,
    nginx,
    node,
    postgres,
    rabbit,
    react,
    sonar,
    spring,
    tailwind
};

export default icons;
